<script setup lang="ts">
interface IdentitySkeletonProps {
  hasFollowingButton?: boolean;
}
const props = defineProps<IdentitySkeletonProps>();
</script>;

<template>
  <div class="hidden lg:flex w-full h-full aspect-[4/1] lg:aspect-[24/6] skeletonLoading !rounded-none" />
  <div class="px-10 flex flex-col gap-6 lg:gap-0 lg:flex-row justify-center lg:justify-between items-center py-6 min-h-40 bg-[var(--base-card-bgColor)]">
    <div class="flex gap-6 lg:flex-row items-center flex-col">
      <div class="w-[120px] h-[120px] !rounded-full skeletonLoading" />
      <div class="flex items-center lg:items-start flex-col gap-2">
        <div class="w-36 h-8  skeletonLoading" />
        <div class="w-40 h-4  skeletonLoading" />
      </div>
    </div>
    <div v-if="props.hasFollowingButton" class="w-[12rem] h-12 skeletonLoading" />
  </div>
</template>;
